module.exports = __webpack_public_path__ + "img/m_6.43fa804c.png";